import { getLicenseTenant, getLicenseTenantUsage } from "@/services/license";
import { ContractCycle, LicenseTenant } from "@/types/license";
import { createAsyncThunk, createSlice, Slice } from "@reduxjs/toolkit";

export interface LicenseTenantState {
  licenseTenant: LicenseTenant | null;
  licenseTenantUsage: ContractCycle | null;
  loading: boolean;
  isError: boolean;
}

const initialState: LicenseTenantState = {
  licenseTenant: null,
  licenseTenantUsage: null,
  loading: false,
  isError: false,
};

export const fetchLicenseTenant = createAsyncThunk("licenseTenant/fetchLicenseTenant", async () => {
  const response = await getLicenseTenant();
  return response;
});

export const fetchLicenseTenantUsage = createAsyncThunk("licenseTenant/fetchLicenseTenantUsage", async () => {
  const response = await getLicenseTenantUsage();
  return response;
});

export const licenseTenantSlice: Slice<LicenseTenantState> = createSlice({
  name: "licenseTenant",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLicenseTenant.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.licenseTenant = null;
        state.licenseTenantUsage = null;
      })
      .addCase(fetchLicenseTenant.fulfilled, (state, action) => {
        state.loading = false;
        state.licenseTenant = action.payload;
        state.licenseTenantUsage = action.payload.currentContractCycle;
      })
      .addCase(fetchLicenseTenant.rejected, (state) => {
        state.loading = false;
        state.isError = true;
      })

      .addCase(fetchLicenseTenantUsage.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.licenseTenantUsage = null;
      })
      .addCase(fetchLicenseTenantUsage.fulfilled, (state, action) => {
        state.loading = false;
        state.licenseTenantUsage = action.payload;
      })
      .addCase(fetchLicenseTenantUsage.rejected, (state) => {
        state.loading = false;
        state.isError = true;
      });
  },
});

export default licenseTenantSlice.reducer;
